import React from 'react';

// Components
import { Box, Divider, Skeleton } from '@mui/material';

import { styled } from '@mui/material/styles';

const Count = styled(Skeleton)(({ theme }) => ({
  borderRadius: 2,
  marginRight: theme.spacing(1),
  width: 25,
}));

const SkeletonContainer = styled('div')(({ skeletonHeight, theme }) => ({
  display: 'grid',
  gridGap: theme.spacing(1),
  gridTemplateColumns: '100%',
  height: skeletonHeight,
  padding: theme.spacing(2),
}));

const Text = styled(Skeleton)(() => ({
  borderRadius: 1,
  height: 18,
  width: '75%',
}));

const Title = styled(Skeleton)(() => ({
  borderRadius: 1,
  height: 25,
  width: '100%',
}));

const SelectorSkeleton = () => {
  return (
    <>
      <SkeletonContainer data-testid="skeleton">
        <Title variant="rectangular" />
        <Box alignItems="center" display="flex">
          <Count variant="rectangular" />
          <Text variant="rectangular" />
        </Box>
      </SkeletonContainer>
      <Divider />
    </>
  );
};

export default SelectorSkeleton;
